var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      directives: [
        {
          name: "kh-loading",
          rawName: "v-kh-loading",
          value: { loading: _vm.loadingScTemplates, absolute: false },
          expression: "{ loading: loadingScTemplates, absolute: false }",
        },
      ],
      class: {
        "screen-control-planning-table": true,
        "screen-control-planning-table--print": _vm.printMode,
        "screen-control-planning-table--dynamic_refresh": _vm.dynamicRefresh,
      },
      attrs: { id: "screenControlTableContainer" },
    },
    [
      _vm.printMode
        ? _vm._l(
            _vm.groupOperationsPrint,
            function (groupOperationPrint, index) {
              return _c(
                "div",
                {
                  key: index,
                  style: {
                    height: _vm.printPageHeigth,
                    padding: _vm.printPadding,
                  },
                },
                [
                  _c(
                    "div",
                    {
                      staticClass:
                        "v-data-table theme--light kh-data-table background-color-alternate",
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "v-data-table__wrapper" },
                        [
                          !_vm.noHeader
                            ? _c("clvr-screen-control-header", {
                                attrs: {
                                  title: _vm.screenControlName,
                                  "sub-title": _vm.operatingRoomName,
                                  date: _vm.parsedDate,
                                  room: _vm.extractRoomFromGroupOperationPrint(
                                    groupOperationPrint
                                  ),
                                },
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "screen-control-planning-table__header",
                            },
                            [
                              _c("clvr-screen-control-table", {
                                ref: "screenControlTable",
                                refInFor: true,
                                attrs: {
                                  headers: _vm.orderedHeaders,
                                  groupOperations: groupOperationPrint,
                                  noRoomCol: _vm.noRoomCol || _vm.printMode,
                                  hideData: _vm.hideData,
                                  aliasOption: _vm.aliasOption,
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ]
                  ),
                ]
              )
            }
          )
        : [
            _c(
              "div",
              {
                staticClass:
                  "v-data-table theme--light kh-data-table background-color-alternate",
              },
              [
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "kh-loading",
                        rawName: "v-kh-loading",
                        value: {
                          loading: _vm.loadingScTemplates,
                          absolute: false,
                        },
                        expression:
                          "{ loading: loadingScTemplates, absolute: false }",
                      },
                    ],
                    staticClass: "v-data-table__wrapper",
                  },
                  [
                    !_vm.noHeader
                      ? _c("clvr-screen-control-header", {
                          attrs: {
                            title: _vm.screenControlName,
                            "sub-title": _vm.operatingRoomName,
                            currentPage: _vm.currentPage,
                            lastPage: _vm.lastPage,
                            date: _vm.parsedDate,
                          },
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "screen-control-planning-table__header" },
                      [
                        _c("clvr-screen-control-table", {
                          ref: "screenControlTable",
                          attrs: {
                            headers: _vm.orderedHeaders,
                            groupOperations: _vm.groupOperations,
                            noRoomCol: _vm.noRoomCol,
                            hideData: _vm.hideData,
                            aliasOption: _vm.aliasOption,
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm.hideData
                      ? _c(
                          "div",
                          {
                            staticClass:
                              "screen-control-planning-table__disabled",
                          },
                          [
                            _vm._v(
                              "\n                    " +
                                _vm._s(
                                  _vm.$t(
                                    "screenControl:screenControl-display_disabled"
                                  )
                                ) +
                                "\n                "
                            ),
                          ]
                        )
                      : _vm._e(),
                  ],
                  1
                ),
              ]
            ),
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }